export default __webpack_public_path__ + "static/media/412.15ec26cf.jpg";